import React from 'react';

const translations = {
  '\u00AE':       '\u00AE', // ®
  '\u1D0D\u1D05': 'MD',     // ᴍᴅ
  '\u1D0D\u1D30': 'MD',     // ᴍᴰ
  '\u1D0D\u1D48': 'MD',     // ᴍᵈ
  '\u1D39\u1D05': 'MD',     // ᴹᴅ
  '\u1D39\u1D30': 'MD',     // ᴹᴰ
  '\u1D39\u1D48': 'MD',     // ᴹᵈ
  '\u1D50\u1D05': 'MD',     // ᵐᴅ
  '\u1D50\u1D30': 'MD',     // ᵐᴰ
  '\u1D50\u1D48': 'MD',     // ᵐᵈ
  '\u2122':       'TM',     // ™
  '\u1D1B\u1D0D': 'TM',     // ᴛᴍ
  '\u1D1B\u1D39': 'TM',     // ᴛᴹ
  '\u1D1B\u1D50': 'TM',     // ᴛᵐ
  '\u1D40\u1D0D': 'TM',     // ᵀᴍ
  '\u1D40\u1D39': 'TM',     // ᵀᴹ
  '\u1D40\u1D50': 'TM',     // ᵀᵐ
  '\u1D57\u1D0D': 'TM',     // ᵗᴍ
  '\u1D57\u1D39': 'TM',     // ᵗᴹ
  '\u1D57\u1D50': 'TM',     // ᵗᵐ
  '\u1D0D\u1D04': 'MC',     // ᴍᴄ
  '\u1D0D\u1D9c': 'MC',     // ᴍᶜ
  '\u1D39\u1D04': 'MC',     // ᴹᴄ
  '\u1D39\u1D9C': 'MC',     // ᴹᶜ
  '\u1D50\u1D04': 'MC',     // ᵐᴄ
  '\u1D50\u1D9c': 'MC',     // ᵐᶜ
};

const pattern = new RegExp(`(${Object.keys(translations).join('|')})`, 'gm')
const breaks = new RegExp(/\n+/, 'gm');

const SymbolFormat = (props) => {
  const {
    elementTag = 'div',
    tag = 'span',
    cssClassName = 'superscripts',
    linebreaks,
    className,
  } = props;

  const ComponentToUse = elementTag;

  const text = props.text || '';

  const paragraphs = linebreaks ? text.split(breaks) : [text];

  return (<ComponentToUse className={className}> {
    paragraphs.map((p) => {
      const symbols = p.split(pattern);
      const children = symbols.map((substr) => {
        return translations[substr] ?
          (React.createElement(tag, {className: cssClassName}, translations[substr])) :
          substr;
      })
      return linebreaks ? (React.createElement('p', null, children)) : children;
    })
  }</ComponentToUse>);
};

export default SymbolFormat;
